export default "__VITE_ASSET__CS$rghGK__"